import { clearMemoryDrafts } from "./memoryDraftStore";

const DRAFT_KEY_PREFIXES = ["draft:", "legal:", "onboarding:"];

export function clearFormDrafts(): void {
  clearMemoryDrafts();
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key == null) continue;
      if (DRAFT_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      sessionStorage.removeItem(key);
    }
  } catch {
    return;
  }
}
